var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5C35 7.83432 27.1645 0 17.5 0C7.8355 0 0 7.83432 0 17.5C0 26.2346 6.39911 33.4747 14.766 34.7877V22.5588H10.3228V17.5H14.766V13.6451C14.766 9.25885 17.379 6.83679 21.3762 6.83679C23.2906 6.83679 25.294 7.17839 25.294 7.17839V11.4852H23.0878C20.9137 11.4852 20.2364 12.8338 20.2364 14.218V17.5012H25.09L24.3143 22.56H20.2364V34.7889C28.6021 33.4758 35.0012 26.237 35.0012 17.5012L35 17.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3119 22.5589L25.0876 17.5001H20.234V14.2169C20.234 12.8327 20.9113 11.4841 23.0854 11.4841H25.2916V7.1773C25.2916 7.1773 23.2895 6.83569 21.3739 6.83569C17.3767 6.83569 14.7636 9.25775 14.7636 13.644V17.4989H10.3204V22.5577H14.7636V34.7866C15.6544 34.9266 16.5677 34.9989 17.4976 34.9989C18.4276 34.9989 19.3409 34.9266 20.2316 34.7866V22.5577H24.3095L24.3119 22.5589Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.0cd961ba9f1df39960a4813e83a90575.svg";
export { ForwardRef as ReactComponent };